export default __webpack_public_path__ + "static/media/seNowpayLogo.0991bf3a.png";